module.exports = __webpack_public_path__ + "img/deposit.abb2c734.png";